import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "c-w-header" }
const _hoisted_2 = { class: "title__name" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = {
  key: 0,
  class: "notification__count"
}

import { RefreshCcw04, Bell03, Moon01 } from "utruckin-icons";
import { useRoute } from "vue-router";
import { computed, onMounted, onUnmounted, ref } from "vue";
import WidgetProfile from "@/components/widget/WidgetProfile.vue";
import { useAppStore } from "@/store/app.store";
import { useTheme } from "@/utils/useMode";
import CustomNotificationModal from "@/components/custom/CustomNotificationModal.vue";
import { useNotificationStore } from "@/features/notification/notification.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'WidgetHeader',
  setup(__props) {

const route = useRoute();
const appStore = useAppStore();
const notificationStore = useNotificationStore();
const { toggleTheme, watchSystemTheme } = useTheme();

let cleanup: (() => void) | null = null;

const notificationModal = ref<boolean>(false);

const routerName = computed(() => {
  const fullRoute = route.name as string;
  return fullRoute.split("-")[0];
});

const refresh = () => {
  appStore.triggerRefresh();
};

const openNotification = () => {
  notificationModal.value = true;
};

onMounted(() => {
  cleanup = watchSystemTheme();
});

onUnmounted(() => {
  cleanup?.();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["title", _unref(route).params.id ? 'link' : ''])
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(routerName.value), 1)
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "refresh",
          onClick: refresh
        }, [
          _createVNode(_unref(RefreshCcw04), { size: 24 })
        ]),
        _createElementVNode("div", {
          class: "notification",
          onClick: openNotification
        }, [
          _createVNode(_unref(Bell03), { size: 24 }),
          (_unref(notificationStore).notificationCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(notificationStore).notificationCount), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "theme",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleTheme) && _unref(toggleTheme)(...args)))
        }, [
          _createVNode(_unref(Moon01), { size: 24 })
        ]),
        _createVNode(WidgetProfile)
      ])
    ]),
    _createVNode(CustomNotificationModal, {
      modelValue: notificationModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((notificationModal).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})